import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BusinessSettingsContext } from "../context/BusinessSettingsContext";

const Navbar = () => {
    const [user, setUser] = useState(null);
    const [query, setQuery] = useState('');
    const [isSearchVisible, setIsSearchVisible] = useState(false);
    const navigate = useNavigate();
    const { settings } = useContext(BusinessSettingsContext);

    const handleSearch = (e) => {
        e.preventDefault();
        if (query.trim() !== '') {
            navigate(`/search?query=${encodeURIComponent(query)}`);
        }
    };

    const toggleSearch = () => {
        setIsSearchVisible(!isSearchVisible);
    };

    useEffect(() => {
        const fetchUser = () => {
            const storedUser = localStorage.getItem("user");
            if (storedUser) {
                setUser(JSON.parse(storedUser));
            } else {
                setUser(null);
            }
        };

        fetchUser();
        window.addEventListener("storage", fetchUser);
        return () => {
            window.removeEventListener("storage", fetchUser);
        };
    }, []);

    return (
        <header className="header">
            <div className="header__content">
                <div className="header__logo">
                    <h1>
                        <Link to="/" style={{ textDecoration: 'none' }}>
                            <img src={settings.website_logo || "Website Name"} alt="Logo" />
                        </Link>
                    </h1>
                </div>

                {/* Desktop Search */}
                <form 
                    className={`header__search ${isSearchVisible ? 'header__search--visible' : ''}`} 
                    onSubmit={handleSearch}
                >
                    <input 
                        type="text" 
                        placeholder="Artist, track or podcast" 
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                    />
                    <button type="submit">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M21.71,20.29,18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z"/>
                        </svg>
                    </button>
                </form>

                <div className="header__actions">
                    {/* Toggle Search on Mobile */}
                    <div className="header__action header__action--search">
                        <button 
                            className="header__action-btn" 
                            type="button" 
                            onClick={toggleSearch}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path d="M21.71,20.29,18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z"/>
                            </svg>
                        </button>
                    </div>

                    {/* Favorite Channels */}
                    <div className="header__action header__action--note">
                        <Link to="/favorite-channels" className="header__action-btn">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-heart" viewBox="0 0 16 16">
                                <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01z"/>
                            </svg>
                        </Link>
                    </div>

                    {/* History */}
                    <div className="header__action header__action--cart">
                        <Link className="header__action-btn" to="/history">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-clock-history" viewBox="0 0 16 16">
                                <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022z"/>
                                <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z"/>
                                <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5"/>
                            </svg>
                        </Link>
                    </div>

                    {/* User */}
                    <div className="header__action header__action--signin">
                        {user ? (
                            <Link className="header__action-btn" to="/profile">
                                <span>{user.name}</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
                                    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
                                    <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8"/>
                                </svg>
                            </Link>
                        ) : (
                            <Link className="header__action-btn" to="/signin">
                                <span>Sign in</span>
                            </Link>
                        )}
                    </div>
                </div>

                {/* Mobile Menu Button (Hamburger) */}
                <button className="header__btn" type="button">
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>
        </header>
    );
};

export default Navbar;